import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import DiseaseLibrary from '@/views/diseaseLibrary/List.vue'
import DiseaseShow from '@/views/diseaseLibrary/Show.vue'
import DiseaseListTwo from '@/views/diseaseLibrary/DIseaseShow.vue'
import Search from '@/views/search/Search'
import SearchList from '@/views/search/List'
import KpVideo from '@/views/kpVideo/List'
import KpVideoShow from '@/views/kpVideo/Show'
import KpVoice from '@/views/kpVoice/List'
import KpVoiceShow from '@/views/kpVoice/Show'
import KpArticle from '@/views/kpArticle/List'
import ListCenter from '@/views/kpArticle/ListCenter'
import KpArticleShow from '@/views/kpArticle/Show'
import SalientDoctor from '@/views/salientDoctor/List'
import SalientDoctorShow from '@/views/salientDoctor/Show'
import DoctorNavList from '@/views/salientDoctor/NavList'
import AnswerList from '@/views/answer/List'
import AnsweShow from '@/views/answer/Show'
import ttHome from '@/views/view-tt/Home'
import ttDiseaseLibrary from '@/views/view-tt/diseaseLibrary/List.vue'
import ttDiseaseShow from '@/views/view-tt/diseaseLibrary/Show.vue'
import ttDiseaseListTwo from '@/views/view-tt/diseaseLibrary/DIseaseShow.vue'
import ttSearch from '@/views/view-tt/search/Search'
import ttSearchList from '@/views/view-tt/search/List'
import ttKpVideo from '@/views/view-tt/kpVideo/List'
import ttKpVideoShow from '@/views/view-tt/kpVideo/Show'
import ttKpVoice from '@/views/view-tt/kpVoice/List'
import ttKpVoiceShow from '@/views/view-tt/kpVoice/Show'
import ttKpArticle from '@/views/view-tt/kpArticle/List'
import ttListCenter from '@/views/view-tt/kpArticle/ListCenter'
import ttKpArticleShow from '@/views/view-tt/kpArticle/Show'
import ttSalientDoctor from '@/views/view-tt/salientDoctor/List'
import ttSalientDoctorShow from '@/views/view-tt/salientDoctor/Show'
import ttDoctorNavList from '@/views/view-tt/salientDoctor/NavList'
import ttAnswerList from '@/views/view-tt/answer/List'
import ttAnsweShow from '@/views/view-tt/answer/Show'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/tt',
      redirect:{path:'/tt/index'+'.html'}
    },
    {
      path: '/',
      name: '首页',
      component: Home,
    },
    {
      path: '/tt/index'+'.html',
      name: '首页',
      component: ttHome,
    },
    {
      path: '/search',
      name: '搜索',
      component: Search,
      redirect: { path: '/search/searchList' },
      children: [
        {
          path: '/search/searchList',
          name: 'searchList',
          component: SearchList,
        }
      ]
    },
    {
      path: '/tt/search'+'.html',
      name: '搜索',
      component: Search,
      redirect: { path: '/view-tt/search/searchList'+'.html' },
      children: [
        {
          path: '/view-tt/search/searchList'+'.html',
          name: 'searchList',
          component: ttSearchList,
        }
      ]
    },
    {
      path: '/diseaseList',
      name: 'diseaseList',
      component: DiseaseLibrary,
    },
    {
      path: '/tt/diseaseList'+'.html',
      name: 'diseaseList',
      component: ttDiseaseLibrary,
    },
    {
      path:'/diseaseShow',
      name:'diseaseShow',
      component:DiseaseShow,
      redirect: { name: 'diseaseListTwo' },
      children:[
        {
          path: '/diseaseShow/diseaseListTwo',
          name: 'diseaseListTwo',
          component: DiseaseListTwo,
        }
      ]
    },
    {
      path:'/tt/diseaseShow'+'.html',
      name:'diseaseShow',
      component:ttDiseaseShow,
      redirect: { name: 'diseaseListTwo' },
      children:[
        {
          path: '/tt/diseaseShow/diseaseListTwo'+'.html',
          name: 'diseaseListTwo',
          component: ttDiseaseListTwo,
        }
      ]
    },
    {
      path:'/kpVideo',
      name:'kpVideo',
      component:KpVideo
    },
    {
      path:'/tt/kpVideo'+'.html',
      name:'kpVideo',
      component:ttKpVideo
    },
    {
      path:'/kpVideo/kpVideoShow/:id',
      name:'KpVideoShow',
      component:KpVideoShow
    },
    {
      path:'/tt/kpVideo/kpVideoShow/:id'+'.html',
      name:'KpVideoShow',
      component:ttKpVideoShow
    },
    {
      path:'/kpVoice',
      name:'kpVoice',
      component:KpVoice
    },
    {
      path:'/tt/kpVoice'+'.html',
      name:'kpVoice',
      component:ttKpVoice
    },
    {
      path:'/kpVoice/kpVoiceShow/:id',
      name:'kpVoiceShow',
      component:KpVoiceShow
    },
    {
      path:'/tt/kpVoice/kpVoiceShow/:id'+'.html',
      name:'kpVoiceShow',
      component:ttKpVoiceShow
    },
    {
      path:'/kpArticle',
      name:'kpArticle',
      component:KpArticle,
      redirect: { name: 'listCenter' },
      children:[
        {
          path:'/kpArticle/listCenter',
          name:'listCenter',
          component:ListCenter
        }
      ]
    },
    {
      path:'/tt/kpArticle'+'.html',
      name:'kpArticle',
      component:ttKpArticle,
      redirect: { name: 'listCenter' },
      children:[
        {
          path:'/tt/kpArticle/listCenter'+'.html',
          name:'listCenter',
          component:ttListCenter
        }
      ]
    },
    {
      path:'/kpArticleShow',
      name:'kpArticleShow',
      component:KpArticleShow
    },
    {
      path:'/tt/kpArticleShow'+'.html',
      name:'kpArticleShow',
      component:ttKpArticleShow
    },
    {
      path:'/salientDoctor',
      name:'salientDoctor',
      component:SalientDoctor
    },
    {
      path:'/tt/salientDoctor'+'.html',
      name:'salientDoctor',
      component:ttSalientDoctor
    },
    {
      path:'/salientDoctor/salientDoctorShow/:id',
      name:'salientDoctorShow',
      component:SalientDoctorShow,

      children:[
        {
          path:'/salientDoctor/salientDoctorShow/doctorNavList/:id/:type',
          name:'doctorNavList',
          component:DoctorNavList
        }
      ]
    },
    {
      path:'/tt/salientDoctor/salientDoctorShow/:id'+'.html',
      name:'salientDoctorShow',
      component:ttSalientDoctorShow,

      children:[
        {
          path:'/tt/salientDoctor/salientDoctorShow/doctorNavList/:id/:type'+'.html',
          name:'doctorNavList',
          component:ttDoctorNavList
        }
      ]
    },
    {
      path:'/answerList',
      name:'answerList',
      component:AnswerList
    },
    {
      path:'/tt/answerList'+'.html',
      name:'answerList',
      component:ttAnswerList
    },
    {
      path:'/answerList/answeShow/:id',
      name:'answeShow',
      component:AnsweShow
    },
    {
      path:'/tt/answerList/answeShow/:id'+'.html',
      name:'answeShow',
      component:ttAnsweShow
    }
  ]
})

// 全局添加 push replace 回调参数
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}




// WEBPACK FOOTER //
// ./src/router/index.js